import SearchOffIcon from '@mui/icons-material/SearchOff';
import { Box, CircularProgress, Grid, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import * as React from 'react';
import { ProvaSelector } from '../components/ProvaSelector';
import { QuestionnaireViewer } from '../components/QuestionnaireViewer';
import { useQuestionnaireViewer } from '../hooks/useQuestionnaireViewer';
import { questionnaireViewerService } from '../services/questionnaireViewerService';

export const QuestionnaireViewerPage: React.FC = () => {
  const [selectedEventUId, setSelectedEventUId] = React.useState<
    string | undefined
  >(undefined);

  const provasQuery = useQuery({
    queryKey: ['viewer-listProvas'],
    queryFn: ({ signal }) => questionnaireViewerService.listProvas(signal),
  });

  const { questions, responses, isLoading, error } =
    useQuestionnaireViewer(selectedEventUId);

  if (!selectedEventUId) {
    return (
      <ProvaSelector
        provas={provasQuery.data || []}
        isLoading={provasQuery.isLoading}
        onSelect={setSelectedEventUId}
      />
    );
  }

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Grid item xs={12} sx={{ marginTop: '5rem' }}>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          minHeight="50vh"
          gap={2}
        >
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: '50%',
              bgcolor: 'grey.100',
              border: '1px solid',
              borderColor: 'grey.300',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <SearchOffIcon sx={{ color: 'text.secondary', fontSize: 28 }} />
          </Box>
          <Box textAlign="center">
            <Typography variant="body1" fontWeight={500} gutterBottom>
              Nenhuma prova encontrada
            </Typography>
          </Box>
        </Box>
      </Grid>
    );
  }

  if (!questions || questions.length === 0) {
    return (
      <Grid item xs={12} sx={{ marginTop: '5rem' }}>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          minHeight="50vh"
          gap={2}
        >
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: '50%',
              bgcolor: 'grey.100',
              border: '1px solid',
              borderColor: 'grey.300',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <SearchOffIcon sx={{ color: 'text.secondary', fontSize: 28 }} />
          </Box>
          <Box textAlign="center">
            <Typography variant="body1" fontWeight={500} gutterBottom>
              Nenhuma prova encontrada
            </Typography>
          </Box>
        </Box>
      </Grid>
    );
  }

  return (
    <QuestionnaireViewer
      questions={questions}
      responses={responses}
      title="Visualização das Respostas"
    />
  );
};
